/**
 * Demo mode on the web: the protocol's synthetic TEST project served in memory, so
 * the dashboard can be read before a backend exists. Viewer role only; nothing is
 * written anywhere. Flag lives in sessionStorage so a reload keeps it and a new tab
 * does not.
 */
import { DEMO_PROJECT_ID, buildDemoDataset, type DemoDataset } from '@treetrack/protocol';

const KEY = 'treetrack.demo';

export function isDemo(): boolean {
  try {
    return sessionStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function startDemo(): void {
  try {
    sessionStorage.setItem(KEY, '1');
  } catch {
    /* private mode: the flag just does not survive a reload */
  }
}

export function stopDemo(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

let cache: DemoDataset | null = null;
/** Centred on San Juan del Sur town; the trees are obviously synthetic (TEST-A-nnn). */
export function demoData(): DemoDataset {
  if (!cache) cache = buildDemoDataset({ centerLat: 11.2525, centerLng: -85.8705 });
  return cache;
}

export { DEMO_PROJECT_ID };
